export const MFE_IDENTIFIER = 'mfe_avis_pricePagesAgencyCards';
